import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const EMPTY_CONTACT = { phone: "", phoneHref: "", email: "" };
const StoreContactContext = createContext(EMPTY_CONTACT);

export const StoreContactProvider = ({ children }) => {
  const [contact, setContact] = useState(EMPTY_CONTACT);

  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${API.replace(/\/web$/, "")}/store-config`, { signal: controller.signal })
      .then(({ data }) => {
        const phone = typeof data.phone === "string" ? data.phone.trim() : "";
        const email = typeof data.email === "string" ? data.email.trim() : "";
        setContact({ phone, email, phoneHref: phone ? `tel:${phone.replace(/[^+0-9]/g, "")}` : "" });
      })
      .catch(() => { /* Missing settings stay hidden, including on request failure. */ });
    return () => controller.abort();
  }, []);

  return <StoreContactContext.Provider value={contact}>{children}</StoreContactContext.Provider>;
};

export const useStoreContact = () => useContext(StoreContactContext);
